import { apiSlice } from "app/api/apiSlice";

export const stateDistictList = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getState: builder.query({
            query: () => {
                return `partner/v1/view_states/?key=qwerty`
            },
            keepUnusedDataFor: 900,
            transformResponse: (response: { data: [] }) => {
                return response.data;
            },
        }),

        getDistrict: builder.query({
            query: (stateId) => {
                return `partner/v1/view_districts?state_id=${stateId}&key=qwerty`
            },
            keepUnusedDataFor: 900,
            transformResponse: (response: { data: [] }) => {
                return response.data;
            }
        }),
        uploadImage: builder.mutation({
            query: (formData: FormData) => ({
                url: 'partner/v1/imageupload/',
                method: 'POST',
                body: formData,
            }),
            transformResponse: (response, meta, arg) => {
                return response
            }
        }),
    }),
})

export const { useGetStateQuery, useGetDistrictQuery, useLazyGetDistrictQuery, useUploadImageMutation } = stateDistictList;